import * as yup from "yup";

export const finaciarChatValidation = yup.object().shape(
  {
    sendOffer: yup.boolean(),
    amount: yup.number().when("sendOffer", {
      is: true,
      then: yup
        .number()
        .typeError("Please enter valid amount")
        .moreThan(0, "Please enter amount more than 0")
        .required("Please enter amount"),
    }),
    roi: yup.number().when("amount", {
      is: (roi) => roi > 0,
      then: yup
        .number()
        .moreThan(0, "Please enter roi more than 0")
        .lessThan(101, "Interest rate must be less than 100%")
        .typeError("Please enter valid roi")
        .required("Please enter rate of interest"),
    }),
    tenure: yup.number().when("roi", {
      is: (tenure) => tenure > 0,
      then: yup
        .number()
        .integer("Tenure value cannot be a float.")
        .moreThan(0, "Please enter Tenure more than 0")
        .lessThan(500, "Tenure should be less than 500 months")
        .typeError("Please enter valid Tenure")
        .required("Please enter Tenure"),
    }),
    // message: yup.string().required("please enter message"),
  },
  [["roi", "tenure"]]
);
